var _rect, _rect2, _rect3, _rect4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDashboardGrid = function SvgDashboardGrid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 5.5,
    height: 5.5,
    rx: 1.2,
    stroke: "currentColor",
    strokeWidth: 1.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 1.5,
    width: 5.5,
    height: 5.5,
    rx: 1.2,
    stroke: "currentColor",
    strokeWidth: 1.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 9,
    width: 5.5,
    height: 5.5,
    rx: 1.2,
    stroke: "currentColor",
    strokeWidth: 1.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 5.5,
    height: 5.5,
    rx: 1.2,
    stroke: "currentColor",
    strokeWidth: 1.3
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboardGrid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboardGrid.dbfc9eb8.svg";
export { ForwardRef as ReactComponent };